import styled from 'styled-components';
export const VideoCont = styled.video`
// box-shadow: rgb(0 48 73 / 14%) 0px 0px 0px 2px, rgb(33 53 65 / 14%) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset;
border-radius: 8px;
height: auto;
width: 50%;
margin: 15%;

`;
export const DivBoxContainer = styled.div`
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
width: -webkit-fill-available;
height: auto;
justify-content: center;
`;
export const DivContentFilters = styled.div`
width: 25vw;
min-width:280px;
max-width: 350px;
height: auto;
min-height: 98vh!important;
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 0px;
padding: 0px 0px 8px 24px;
background-color: #FFFFFF;
@media only screen and (min-width:0px) and (max-width:1100px){
  display:${(prop) => prop.params.id ? 'none' : 'flex'};
  width: -webkit-fill-available;
}
`;

export const DivFlexColumn = styled.div`
background-color: rgba(255, 255, 255, 0.8);
width: -webkit-fill-available;
height: auto;
display: flex;
flex-direction: column;
align-items: center;
padding: 16px;
max-height: 85vh;
min-height: 85vh;
overflow-y: auto;
border-radius: 8px;
margin-right: 16px;
margin-top: 8px;
// border: solid 1px blue;
justify-content: flex-start;


&::-webkit-scrollbar {
  height: 4px;
  width: 3px;
  background-color: transparent !important;
}

&::-webkit-scrollbar-track {
  background: transparent;
}

&::-webkit-scrollbar-thumb {
  background-color: #003049 !important;
  border-radius: 8px;
}
// box-shadow: rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;
@media only screen and (min-width:0px) and (max-width:1100px){
  display:${(prop) => prop.params.id ? 'flex' : 'none'};
  margin-right: 0px;

  }
`;

export const ActionBtn = styled.img`
  max-width:28px;
  max-height:28px;
  width:28px;
  height:28px;
  border-radius: 8px;
  border-color: #dadce0;
  box-shadow: rgba(0, 0, 0, .1) 0 1px 1px;
  background-color: #FFFFFF;
  padding:5px;
  cursor:pointer;
  &:active{
    zoom: 95%;
  }
`;


export const Input = styled.input`
box-shadow: rgb(0 0 0 / 6%) 0px 2px 4px 0px inset;
  width: -webkit-fill-available;
  min-width: -webkit-fill-available;
  margin: 8px 8px;
  padding:5px;
  border:none;
  outline: none;
  background:#FFFFFF;
  border-radius:8px;
  height:26px;
  min-height:26px;
  max-width: 10vw;
  font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #07082c;
  &:placeholder{
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #07082c;
  }
`;

export const ContainerBox = styled.div`
width: -webkit-fill-available;
height: calc(100vh - 125px);
overflow-y: auto;
max-width: calc(100vw - 84px);
gap: 16px;
display: flex;
flex-direction: row;
align-items: flex-start;
background-color: #FFFFFF;
border-radius: 8px;
box-shadow: 0px 1.5px 2px 0px rgba(16, 24, 40, 0.10);
border: 1px solid var(--Neutral-Gray-Gray-100, #E0E2E7);
`;

export const DivRow = styled.div`
width: -webkit-fill-available;
display: flex;
flex-direction: row;
align-items: center;
gap: 16px;
padding: 0.5em 0.5em 0.5em;
// background-color: #FFFFFF;

justify-content: space-between;
`;

export const DivColumn1 = styled.div`
width: auto;
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 5px;
// padding: 0.5em 0.5em 0.5em;
// background-color: #FFFFFF;

// justify-content: space-between;
`;
export const DivRow1 = styled.div`
width: auto;
display: flex;
flex-direction: row;
align-items: flex-start;
gap: 5px;

`;
export const ScrollContainer = styled.div`
width: -webkit-fill-available;
height: auto;
max-height: calc(100vh - 31vh) !important;
overflow-y: auto;
overflow-x: hidden;
gap: 0px;
display: flex;
flex-direction: column;
align-items: center;
margin: 0%;
scroll-behavior: smooth;
padding: 8px 0px 0px 0px;
border-top: 2px solid #003049;
justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

`;


export const Text = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #003049;

`;
export const Text1 = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #003049;

`;